import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import DirectPaymentFileUploader from './AssesmentScreenCompontents/DirectPaymentFileUploader';
import AssesmentScreenData from './AssesmentScreenData';
import DataLoading from '../../components/common/DataLoading';
import { directPayment } from '../../utils/api';
import FarmContext from '../../store/farm-context';

export default function TabPanel(props) {
  const { year, children, value, index, ...other } = props;
  const [
    isDirectPaymentApplicationAvailable,
    setIsDirectPaymentApplicationAvailable,
  ] = useState(false);
  const [data, setData] = useState(null);
  const history = useHistory();
  const farmCTX = useContext(FarmContext);

  const updateDirectPaymentYear = () => {
    directPayment
      .year(farmCTX.farmID, year)
      .then((result) => {
        if (result.status === 200) {
          if (result.data.length > 0) {
            setIsDirectPaymentApplicationAvailable(true);
          } else {
            setIsDirectPaymentApplicationAvailable(false);
          }
          setData(result.data);
        } else {
          history.push('/login');
        }
      })
      .catch((err) => {
        try {
          if (err.response.status === 403) {
            history.push('/login');
          }
        } catch (e) {}
      });
  };

  useEffect(() => {
    if (value === index) updateDirectPaymentYear();
    return () => {
      setData(null);
    };
    // eslint-disable-next-line
  }, [farmCTX.farmID, year, value]);

  return (
    <Box
      component="div"
      sx={{ minHeight: '60vh' }}
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {data == null ? (
            <DataLoading />
          ) : (
            <>
              {isDirectPaymentApplicationAvailable && data.length > 0 ? (
                <AssesmentScreenData
                  data={data[0]}
                  setDirectPaymentAvailable={
                    setIsDirectPaymentApplicationAvailable
                  }
                  setData={setData}
                />
              ) : (
                <DirectPaymentFileUploader
                  update={updateDirectPaymentYear}
                  changeYear={props.changeYear}
                />
              )}
            </>
          )}
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  year: PropTypes.any.isRequired,
};
